export default {
  BusinessStockSynchronizationDetail: {
    basicInformation: '基础信息',
    adjustCode: '逻数据同步单号',
    warehouseCode: '逻辑仓编码',
    warehouseName: '逻辑仓名称',
    commodityDetails: '商品明细',
    realityNum: '计划调整差异数量',
    planNum: '调整差异数量',
  }
};
